/*
 * @Description: user actions
 */
import { ActionTree, ActionContext } from 'vuex'
import { RootState } from '@/store'
import { state, DataAnalysisState } from './state'
import { Mutations } from './mutations'
import { AnalysisActionTypes } from './action-types'
import { AnalysisMutationTypes } from './mutation-types'


type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>
} & Omit<ActionContext<DataAnalysisState, RootState>, 'commit'>

export interface Actions {
  [AnalysisActionTypes.ACTION_ANALYSIS_SCREENFULL](
    { commit }: AugmentedActionContext,
    screenfull: boolean
  ): void
  [AnalysisActionTypes.ACTION_ANALYSIS_SCREENTHEM](
    { commit }: AugmentedActionContext,
    screenTheme: string
  ): void
}

export const actions: ActionTree<DataAnalysisState, RootState> & Actions = {
  [AnalysisActionTypes.ACTION_ANALYSIS_SCREENFULL](
    { commit }: AugmentedActionContext,screenfull: boolean) {
    commit(AnalysisMutationTypes.SET_SCREENFULL, screenfull)
  },
  [AnalysisActionTypes.ACTION_ANALYSIS_SCREENTHEM](
    { commit }: AugmentedActionContext,screenTheme: string) {
    commit(AnalysisMutationTypes.SET_SCREENTHEME, screenTheme)
  },
}
